import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ChevronLeft, Calendar } from "lucide-react";
import Seo from "../components/Seo";

export default function BlogDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(r => setP(r.data)).catch(() => setP(false)); }, [slug]);
  if (p === null) return <div className="pt-32 container-p muted">Loading…</div>;
  if (p === false) return <div className="pt-32 container-p"><Link to="/blog" className="btn-outline">Back</Link></div>;

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: p.title,
    image: [p.image],
    author: { "@type": "Organization", name: p.author },
    publisher: { "@type": "Organization", name: "Acchajee Travels" },
    datePublished: p.created_at,
    description: p.excerpt,
  };

  return (
    <div className="pt-16 lg:pt-20">
      <Seo title={p.title} path={`/blog/${p.slug}`} description={p.excerpt} image={p.image} type="article" schema={articleSchema} />
      <div className="relative h-[55vh] overflow-hidden">
        <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/10" />
        <div className="container-p relative h-full flex flex-col justify-end pb-10 z-10 text-white">
          <Link to="/blog" className="inline-flex items-center gap-1 text-sm mb-4 opacity-90"><ChevronLeft className="w-4 h-4" /> Blog</Link>
          <div className="text-xs uppercase tracking-widest text-[#FF7D00] mb-2">{p.category}</div>
          <h1 className="h1 text-white max-w-3xl">{p.title}</h1>
          <div className="flex items-center gap-4 mt-4 text-sm opacity-90"><span className="flex items-center gap-1"><Calendar className="w-4 h-4" /> {new Date(p.created_at).toLocaleDateString()}</span><span>By {p.author}</span></div>
        </div>
      </div>
      <article className="container-p py-16 max-w-3xl prose">
        <p className="text-lg muted leading-relaxed mb-6">{p.excerpt}</p>
        <div className="whitespace-pre-wrap text-[#0A2540] leading-relaxed">{p.content}</div>
      </article>
    </div>
  );
}
